import type { Step } from "@totalenergiescode/mobility-business-rev-design-system";
import { Stepper } from "@totalenergiescode/mobility-business-rev-design-system";
import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";

import { StyledStepperContainer } from "@/components/FormData/lib/layout/Stepper/styles";

const StepperComponent = () => {
  const { form } = useFormDataContext();

  const current_step = form.findCurrentStep();
  const current_step_number =
    current_step === undefined ? 0 : current_step.number - 1;

  return (
    <StyledStepperContainer>
      <Stepper
        steps={
          // TODO: add the summary step to this list
          form.steps.filter((step) => step.isRenderable()) as unknown as Step[] // FIX: This part must be improved/fix since the step doensn't properly map the Stepper type
        }
        activeStep={current_step_number}
        isLiniar={false}
        subLabelProps={{
          errorText: "Error",
          completedText: "Completed",
          currentText: "Current",
          defaultText: "Default",
        }}
        isMobile={false}
      />
    </StyledStepperContainer>
  );
};

export default StepperComponent;
